export const SET_TEMPLATE_DATA = "SET_TEMPLATE_DATA";
export const USER_FETCHING_INIT = "USER_FETCHING_INIT";
export const USER_FETCHING_COMPLETE = "USER_FETCHING_COMPLETE";
